const hostname = window.location.hostname.toLowerCase();
const isPublicSite = hostname == "www.addedvalue.co.il" || hostname == "addedvalue.co.il";

module.exports = isPublicSite;